"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var HtmlTooltipUI = (0, _styles.withStyles)(function (theme) {
  return {
    tooltip: {
      padding: theme.spacing(3),
      backgroundColor: theme.palette.NEUTRAL000,
      boxShadow: theme.shadows[3],
      maxWidth: 'none',
      color: theme.palette.NEUTRAL700
    }
  };
})(_core.Tooltip);

/**
 * @deprecated HtmlTooltip is deprecated as of version 1.10.0. Please use the Tooltip or DocsTooltip component instead.
 */

var HtmlTooltip = function HtmlTooltip(_ref) {
  var props = _extends({}, _ref);
  return /*#__PURE__*/_react.default.createElement(HtmlTooltipUI, props);
};
var _default = HtmlTooltip;
exports.default = _default;